var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 6.25C14.0815 6.25 14.3995 6.3817 14.6339 6.61612C14.8683 6.85054 15 7.16848 15 7.5C15 7.83152 14.8683 8.14946 14.6339 8.38388C14.3995 8.6183 14.0815 8.75 13.75 8.75C6.47391 8.75 9.30068 8.75 1.25 8.75C0.91848 8.75 0.600536 8.6183 0.366117 8.38388C0.131696 8.14946 0 7.83152 0 7.5C0 7.16848 0.131696 6.85054 0.366117 6.61612C0.600536 6.3817 0.91848 6.25 1.25 6.25C8.52608 6.25 5.69932 6.25 13.75 6.25Z",
    fill: "#141414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinus);
export default __webpack_public_path__ + "static/media/minus.c24e75f7dcb4d66eb94f7cce79017b80.svg";
export { ForwardRef as ReactComponent };